module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-about"
  }, [_c('div', {
    staticClass: "tab-about__tabs"
  }, [_c('div', {
    staticClass: "tab-about__desktop"
  }, _vm._l((_vm.props.tabs), function(tab, i) {
    return _c('div', {
      staticClass: "tab-about__tab",
      class: {
        'tab-about__tab--active': _vm.hoverTab === i
      },
      style: ({
        backgroundImage: 'url(' + tab.image + ')'
      }),
      on: {
        "mouseover": function($event) {
          _vm.hoverTab = i
        },
        "mouseleave": function($event) {
          _vm.hoverTab = i
        }
      }
    }, [_c('div', {
      staticClass: "tab-about__overlay"
    }), _c('div', {
      staticClass: "tab-about__title",
      domProps: {
        "innerHTML": _vm._s(tab.title)
      }
    }), _c('transition', {
      attrs: {
        "name": "fade-in-tab-text"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.hoverTab === i),
        expression: "hoverTab === i"
      }],
      staticClass: "tab-about__content",
      domProps: {
        "innerHTML": _vm._s(tab.content)
      }
    })])], 1)
  }), 0), _c('div', {
    staticClass: "tab-about__clickable"
  }, _vm._l((_vm.props.tabs), function(tab, i) {
    return _c('div', {
      staticClass: "tab-about__tab",
      class: {
        'tab-about__tab--active': _vm.activeTab === i
      },
      style: ({
        backgroundImage: 'url(' + tab.image + ')'
      }),
      on: {
        "mouseover": function($event) {
          _vm.activeTab = i
        },
        "mouseleave": function($event) {
          _vm.activeTab = i
        }
      }
    }, [_c('div', {
      staticClass: "tab-about__overlay"
    }), _c('div', {
      staticClass: "tab-about__title",
      domProps: {
        "innerHTML": _vm._s(tab.title)
      }
    }), _c('transition', {
      attrs: {
        "name": "fade-in-tab-text"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.activeTab === i),
        expression: "activeTab === i"
      }],
      staticClass: "tab-about__content",
      domProps: {
        "innerHTML": _vm._s(tab.content)
      }
    })])], 1)
  }), 0), _c('div', {
    staticClass: "tab-about__mobile"
  }, _vm._l((_vm.props.tabs), function(tab, i) {
    return _c('div', {
      staticClass: "tab-about__mobile-tab",
      class: {
        'tab-about__mobile-tab--active': _vm.mobileTabs.includes(i)
      },
      style: ({
        backgroundImage: 'url(' + tab.image + ')'
      }),
      on: {
        "click": function($event) {
          return _vm.toggleMobileTab(i)
        }
      }
    }, [_c('div', {
      staticClass: "tab-about__mobile-overlay"
    }), _c('div', {
      staticClass: "tab-about__mobile-label"
    }, [_c('div', {
      staticClass: "tab-about__mobile-selector"
    }, [_c('transition', {
      attrs: {
        "name": "fade-in-label"
      }
    }, [(!_vm.mobileTabs.includes(i)) ? _c('div', {
      staticClass: "tab-about__mobile-selector--plus"
    }, [_vm._v("+")]) : _vm._e()]), _c('transition', {
      attrs: {
        "name": "fade-in-label"
      }
    }, [(_vm.mobileTabs.includes(i)) ? _c('div', {
      staticClass: "tab-about__mobile-selector--minus"
    }, [_vm._v("-")]) : _vm._e()])], 1), _c('div', {
      staticClass: "tab-about__mobile-title",
      domProps: {
        "innerHTML": _vm._s(tab.title)
      }
    })]), _c('transition', {
      attrs: {
        "name": "fade-in-label"
      }
    }, [(_vm.mobileTabs.includes(i)) ? _c('div', {
      staticClass: "tab-about__mobile-content",
      domProps: {
        "innerHTML": _vm._s(tab.content)
      }
    }) : _vm._e()])], 1)
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20a6fbb5","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/tab/tab-about/tab-about.pug
// module id = 547
// module chunks = 1